/**
 * Guided contact flow: ids are API contract (stable strings).
 */

export const intentOptionDefs = [
  {
    id: "software_engineering",
    readMoreHref: "/services/software-engineering",
  },
  {
    id: "it_support_rmm",
    readMoreHref: "/services/it-support-rmm",
  },
  {
    id: "ai_enablement",
    readMoreHref: "/services/ai-enablement",
  },
  {
    id: "general",
    readMoreHref: "/services",
  },
] as const;

export type IntentId = (typeof intentOptionDefs)[number]["id"];

export const INTENT_ID_TUPLE = [
  intentOptionDefs[0].id,
  intentOptionDefs[1].id,
  intentOptionDefs[2].id,
  intentOptionDefs[3].id,
] as const;

export const timelineOptionDefs = [
  { id: "urgent" },
  { id: "this_quarter" },
  { id: "later" },
  { id: "exploring" },
] as const;

export type TimelineId = (typeof timelineOptionDefs)[number]["id"];

export const TIMELINE_ID_TUPLE = [
  timelineOptionDefs[0].id,
  timelineOptionDefs[1].id,
  timelineOptionDefs[2].id,
  timelineOptionDefs[3].id,
] as const;

export const contactFlowStepIds = [
  "intent",
  "timeline",
  "needs",
  "contact",
  "consent",
] as const;

export const TOTAL_STEPS = contactFlowStepIds.length;
